export { BvlSwitchComponent as BvlSwitch } from './switch.component';
export { BvlSwitchModule } from './switch.module';